export default "__VITE_ASSET__Djw3SmCZ__"